import {Component, OnInit, inject} from '@angular/core';
import {DataService} from '../../../services/data.service';
import {AccessService} from '../../../services/access.service';
import {LightStatus} from "../../interfaces";
import {LocalStorageService} from "../../../services/local-storage.service";
import {NgIf, NgFor, NgClass, DecimalPipe, DatePipe, KeyValuePipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {FormsModule} from '@angular/forms';
import {DebounceKeyupDirective} from '../../../directives/debounce-keyup.directive';
import {PopoverModule} from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-light-list',
    templateUrl: './light-list.component.html',
    styleUrl: './light-list.component.scss',
    imports: [NgIf, RouterLink, PaginationModule, FormsModule, DebounceKeyupDirective, PopoverModule, NgFor, NgClass, DecimalPipe, DatePipe, KeyValuePipe]
})
export class LightListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);

    readonly LightStatus = LightStatus;

    paginConfig = {
        itemsPerPage: 25,
        page: 1
    };
    filter = {
        order: 'number',
        reverse: true,
        showPast: false,

        number: '',
        status: [],
        title: '',
        id_region: 'all',
        id_department: 'all',
        id_country: 'all',
        lead: '',
        update: '',
    };

    regions: any[] = [];
    departments: any[] = [];
    countries: any[] = [];
    projects: any[] = [];
    stats: any;

    // set initially to a high value to we can set the filter page, else it would always set the current page to 1
    totalProjects = 1000;

    exporting = false;

    highlightedRow = null;

    ngOnInit(): void {
        this.dataService.request("Country/listForDashboard").subscribe(response => {
            this.countries = response.countries;
        })

        this.dataService.request("Department/listForProject").subscribe(response => {
            this.departments = response.departments;
        })

        this.dataService.request("Region/listForProject").subscribe(response => {
            this.regions = response.regions;
        })

        this.highlightedRow = this.localStorageService.getItem('light-highlighted-row');

        this.filter = this.localStorageService.getItem('light-filter');
        if (!this.filter) {
            this.resetFilter();
        }
        this.loadProjects(this.paginConfig);
    }

    /*
     * This is used to override the default comparator function of keyvalue pipe in angular - https://angular.io/api/common/KeyValuePipe
     */
    asIsOrder() {
        return 0;
    }

    setFilterStatus(status): void {
        this.resetFilter();
        this.filter.status = status;
        this.loadProjects(this.paginConfig);
    }

    resetFilter(): void {
        this.filter = {
            order: 'number',
            reverse: true,
            showPast: false,

            number: '',
            status: [],
            title: '',
            id_region: 'all',
            id_department: 'all',
            id_country: 'all',
            lead: '',
            update: 'all',
        };

        this.paginConfig.page = 1;
    }

    resetFilterAndReload(): void {
        this.resetFilter();
        this.loadProjects(this.paginConfig);
    }

    setOrder(order): void {
        this.filter.order = order;
        this.filter.reverse = !this.filter.reverse;
        this.loadProjects(this.paginConfig);
    }

    loadProjects(event): void {
        this.localStorageService.setItem('light-filter', this.filter);

        this.paginConfig = event;

        this.projects = [];
        this.dataService.request('Light/listAll', {
            filter: this.filter,
            pagination: this.paginConfig
        }).subscribe(response => {
            this.projects = response.projects;
            this.totalProjects = parseInt(response.totalProjects, 10);
            this.stats = response.stats;

            // iterate stats object and parse values as number
            for (const key in this.stats) {
                this.stats[key] = parseInt(this.stats[key], 10);
            }

            // set default values for stats
            this.stats.Offen = this.stats.Offen ?? 0;
            this.stats['In Arbeit'] = this.stats['In Arbeit'] ?? 0;
            this.stats.Erledigt = this.stats.Erledigt ?? 0;
            this.stats['On Hold'] = this.stats['On Hold'] ?? 0;
        });
    }

    exportProjects(): void {
        this.exporting = true;
        this.dataService.request("Export/light", {
            filter: this.filter
        }).subscribe(response => {
            this.exporting = false;
            const link = document.createElement('a');

            link.setAttribute('href', 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + response.export.data);
            link.setAttribute('download', response.export.filename);
            link.click();
        });
    }

    highlightRow(id): void {
        this.highlightedRow = id;

        this.localStorageService.setItem('light-highlighted-row', id);
    }
}
